import React from 'react'
import { UserProfileModel } from 'mvppoker-portal-common/api'
import { ThumbDown, ThumbUp } from '@mui/icons-material'
import './FriendsRequestsListItem.scss'
import { MVPButton } from '../../../Buttons/MVPButton'

export interface FriendsRequestsListItemActions
{
	clickAccept: (userProfile: UserProfileModel) => void,
	clickReject: (userProfile: UserProfileModel) => void,
}
export interface FriendsRequestsListItemProps extends FriendsRequestsListItemActions
{
	userProfile: UserProfileModel,
}

export const FriendsRequestsListItem: React.FC<FriendsRequestsListItemProps> = ({ userProfile, clickAccept, clickReject }) =>
{
    const { name, avatar } = userProfile.info

	return (
		<div className='friends-requests-list-item mvp-list-item'>
            <img id='user-avatar' className='avatar' src={avatar} alt='avatar' style={{ width:'10%'}}/>
            <p className='big' style={{ width:'40%'}}>{name}</p>
            <MVPButton id='accept-friend-button' className='friends-requests-button' onClick={() => clickAccept(userProfile)}>
                <ThumbUp />
                ACCEPT
            </MVPButton>
            <MVPButton id='reject-friend-button' className='friends-requests-button' onClick={() => clickReject(userProfile)}>
                <ThumbDown />
                REJECT
            </MVPButton>
		</div>
	)
}
